var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgShape2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1130,
    height: 798,
    viewBox: "0 0 1130 798",
    fill: "#5E6E78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1312.47 274.985C1182.93 85.9868 965.442 -38 719 -38C321.907 -38 0 283.907 0 681C0 738.771 6.81372 794.95 19.6807 848.779L385.824 482.636C420.922 447.538 477.828 447.538 512.926 482.636L808.875 778.585L1312.47 274.985Z",
    fill: "#5E6E78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397.93 443.734L872.426 969.239C837.328 1004.34 780.422 1004.34 745.324 969.239L449.375 673.29L91.1038 1031.56C214.1 1251.39 449.195 1400 719 1400C1116.09 1400 1438 1078.09 1438 681C1438 597.861 1423.89 518.017 1397.93 443.734Z",
    fill: "#5E6E78"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShape2);
export default __webpack_public_path__ + "static/media/bg-shape-2.6bfaf73b40fc136a5d4540286e36dbff.svg";
export { ForwardRef as ReactComponent };